export default __webpack_public_path__ + "static/media/avatar.a285cf30.jpg";